export default __webpack_public_path__ + "static/media/Q1_2.07bc4242.png";